import { ActionTypes } from "./actionType";
import { AuthActionTypes, AuthState } from "./types";

const initState: AuthState = {
  User: null,
};

export const authReducer = (
  state = initState,
  action: AuthActionTypes
): AuthState => {
  switch (action.type) {
    case ActionTypes.setUserInfo:
      const newAuth: AuthState = {
        ...state,
        User: action.payload.User ? action.payload.User : null,
      };
      return newAuth;
    default:
      return state;
  }
};
